export default __webpack_public_path__ + "static/media/sums.44a8f4c7.svg";